<script setup lang="ts">
import CorporateGovernanceHero from '@/domains/investor/corporate-governance/main/components/Hero/Hero.vue'
import ManagementTeamWrapper from '~/domains/investor/corporate-governance/components/ManagementTeamWrapper/ManagementTeamWrapper.vue'
import CorporateGovernanceDuties from '@/domains/investor/corporate-governance/main/components/Duties/Duties.vue'
import { useFetchBoard } from '@/domains/investor/composables/useFetchBoard'

const { t, locale } = useI18n()

definePageMeta({
  layout: 'investor',
})

useHead(() => ({
  title: t('pageTitles.investorManagementBoard.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorManagementBoard.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorManagementBoard.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorManagementBoard.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorManagementBoard.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorManagementBoard.canonical.pl'),
    },
  ],
}))

const { fetchBoard } = await useFetchBoard()
const response = await fetchBoard('coporate_governance_managment_board')
const presidentResponse = await fetchBoard('coporate_governance_president_board')
const managementTeam = response.data.value
const presidentTeam = presidentResponse.data.value
</script>

<template>
  <div class="corporateGovernancePage">
    <CorporateGovernanceHero />

    <ManagementTeamWrapper />

    <CorporateGovernanceDuties
      v-if="managementTeam.boardMembers"
      :members="presidentTeam.boardMembers.concat(managementTeam.boardMembers)"
    />
  </div>
</template>
